import { action } from '@ember/object';
import { service } from '@ember/service';

import type { PopupData, Service } from 'webapp-types';

import PopupInnerModalComponent from 'webapp/components/popup/inner/modal';
import SubmitButtonComponent from 'webapp/components/submit-button';

export default class AccountBillingCancellationFlowPopupSubscriptionChangedComponent extends PopupInnerModalComponent<PopupData.None> {
	@service('account') declare accountService: Service.Account;
	@service('billing') declare billingService: Service.Billing;
	@service('flow/cancellation') declare flowCancellationService: Service.Flow.Cancellation;
	@service('request') declare requestService: Service.Request;

	@action
	resubscribe(): void {
		const latestActivePlan = this.flowCancellationService.latestActivePlan;

		if (!latestActivePlan) {
			return;
		}

		this.submitInProgress = true;
		this.billingService
			.switchPlanWithoutConfirm(
				latestActivePlan,
				undefined,
				this.flowCancellationService.trackingOriginForBillingPeriodChangePopup,
			)
			.finally(() => {
				this.submitInProgress = false;
			})
			.catch(this.requestService.handleGenericThrownError.bind(this.requestService));
	}
	<template>
		<div class="content">

			<img src="/images/svg/cancel.svg" height="145" alt />
			<h2>Your subscription has been canceled</h2>
			<p>
				We're really sorry to see you go, but thanks for giving us a try. Your subscription
				will end on
				<strong>{{this.billingService.formattedActiveUntil}}</strong>.
			</p>
			<p>
				If you change your mind, you can always come back and continue where you left off.
				Your account will remain exactly as it is now.
			</p>
			<p>
				In case you canceled by mistake, you can easily re-subscribe by clicking on the
				button below.
			</p>

			<div class="controls2 controls2--center">
				<SubmitButtonComponent
					@text="Re-subscribe"
					@size="big"
					@noDelay={{true}}
					@submitInProgress={{this.submitInProgress}}
					@onTrigger={{this.resubscribe}}
					@icon="Refresh"
				/>
			</div>
		</div>
	</template>
}
